import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import FlowButton from "./FlowButton";
import RemoteSubmitButton from "../../controls/buttons/RemoteSubmitButton";

class PolyFlowBottomBar extends Component {
    render() {
        const {flowKey, forms, id, hideOnLast, formNames} = this.props;
        const multiNames = Array.isArray(formNames[flowKey.value]);
        const getFormName = () => {
            if (multiNames) {
                return formNames[flowKey.value].find((name) => {
                    return !!forms[name] && !!forms[name].values;
                });
            } else {
                return !!forms[formNames[flowKey.value]] ? formNames[flowKey.value] : null;
            }
        };
        const formName = getFormName();

        return (hideOnLast ? (flowKey.value !== flowKey.size - 1) : true) ? (
            <div className="polyflow-bottom-bar-container">
                {
                    formNames[flowKey.value] && !!formName ? (
                        <RemoteSubmitButton formName={formName} color="success">{multiNames ? "Save" : "Save and Continue"}</RemoteSubmitButton>
                    ) : (
                        <FlowButton id={id} onClick="inc" color="primary">Skip to Next Page</FlowButton>
                    )
                }
            </div>
        ) : null;
    }
}

PolyFlowBottomBar.propTypes = {
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    formNames: PropTypes.array.isRequired,
    hideOnLast: PropTypes.bool,
};

const mapStateToProps = (state, props) => ({
    flowKey: state.display.flowKeys.find(key => key.id === props.id),
    forms: state.form,
});

export default connect(mapStateToProps)(PolyFlowBottomBar);



// WEBPACK FOOTER //
// ./src/components/flow/PolyFlow/PolyFlowBottomBar.js